import cusTab from './Tab'
import Wrap from './Wrap'
// import Turning from './Turning'
import Search from './Search'
import cusTable from './Table'
// import BigImg from './BigImg'

export default (Vue)=>{
  Vue.component("cusTab", cusTab); // tab标签栏
  Vue.component("Wrap", Wrap); // 一个基本容器
  // Vue.component("Turning", Turning); // 翻页组件
  Vue.component("Search", Search); // 搜索组件
  Vue.component("cusTable", cusTable); // 表格组件
  // Vue.component("BigImg", BigImg); // 图片放大预览组件
}
